import React from 'react';
import PropTypes from 'prop-types';

import { Text, Icon } from 'components/common/Elements/Elements';

import classes from './BodyTooltip.module.scss';

const BodyTooltip = ({ name, data = [], subName, icon }) => {
  return (
    <section className={classes.wrap}>
      <Text
        type={'p'}
        className={classes.title}
        weight="m"
      >{`${name} (${data.length})`}</Text>
      {data.map((item, index) => (
        <div className={classes.notifWrap} key={index}>
          <Icon icon={icon} className={classes.icon} size="16px" />
          <Text type={'p'} className={classes.name} weight="m">
            {item[`${subName}`] || '-'}
          </Text>
        </div>
      ))}
    </section>
  );
};

BodyTooltip.propTypes = {
  name: PropTypes.string,
  data: PropTypes.array,
  subName: PropTypes.string,
  icon: PropTypes.string
};

export default BodyTooltip;
